import { SET_CUSTOMER_TYPE } from '../actions/actionTypes'

const initialState = {
    customerType: null,
}

export const customerTypeReducer = (state = initialState, action) => {
    if(action.type === SET_CUSTOMER_TYPE){
        return {
            ...state,
            customerType: action.payload.customerType
        }
    }
    else {
        return state
    }
}
